/**
 * Fixtures for tests and Storybook: tier1/tier2/tier3 entitlement and entity shapes.
 */

import type {
  EntityEntitlementForSchemaResponse,
  EntityEntitlementForTargetResponse,
  EntityEntitlementsResponse,
} from '../types/EntityEntitlements';

import sponsoredEntityDetailJson from './sponsored-entity-detail.json';
import tier1ImperatorJson from './tier1-imperator.json';
import tier2SponsoredImperatorJson from './tier2-sponsored-imperator.json';
import tier3SponsoredImperatorJson from './tier3-sponsored-imperator.json';

/** Tier1 imperator entitlements (GET /mgmt/Entitlements/entity): Requestor, EntitySets, EntityEntitlements. */
export const tier1Imperator: EntityEntitlementsResponse =
  tier1ImperatorJson as EntityEntitlementsResponse;

/** Tier2 imperator-sponsored Sponsored entity entitlement (create/edit form fields, bindings, PolicyRules). */
export const tier2SponsoredImperator: EntityEntitlementForSchemaResponse =
  tier2SponsoredImperatorJson as EntityEntitlementForSchemaResponse;

/** Tier3 imperator-sponsored Sponsored entity entitlement (Target, Requestor, TargetEntitlements, CreateEntity, DeleteEntity). */
export const tier3SponsoredImperator: EntityEntitlementForTargetResponse =
  tier3SponsoredImperatorJson as EntityEntitlementForTargetResponse;

/** Sponsored entity detail (GET entity by id response): same user as tier2/tier3 fixtures (Id 70011081, wheelern2). */
export const sponsoredEntityDetail: Record<string, unknown> = {
  ...sponsoredEntityDetailJson,
  _attributesRequested: Object.keys(sponsoredEntityDetailJson as object),
  _skipReferenceExpansion: false,
} as Record<string, unknown>;
